// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /****************************/
  /*------Color Palettes------*/
  /****************************/
  /* BluePrint Colors */
  --bp-light-gray1: #d3d8de;
  --bp-light-gray2: #dce0e5;
  --bp-light-gray3: #edeff2;
  --bp-light-gray4: #edeff2;
  --bp-light-gray5: #f6f7f9;
  --bp-gray3: #8f99a8;
  --bp-gray4: #abb3bf;
  --bp-gray5: #c5cbd3;
  --bp-dark-gray4: #383e47;
  --bp-dark-gray5: #404854;
  --bp-red2: #ac2f33;
  --bp-red3: #cd4246;
  --bp-orange4: #ec9a3c;
  --bp-gold4: #f0b726;
  --bp-cerulean3: #147eb3;

  --muted-text: #5f6b7c;
  --text-color: #1c2127;
  --text-med-color: #262c31;
  --text-dark-color: #18191b;

  /* UU Brand Colors */
  --uu-utah-red: #be0000;
  --uu-utah-red-hover: #930000;
  --uu-granite-peak: #708e99;
  --uu-zion-cinder-cone: #707271;
  --uu-gray-50: #939598;
  --uu-salt-flat-gray: #e2e6e6;
  --uu-lake-powell: #4f868e;
  --uu-great-salt-lake: #3abfc0;
  --uu-blue-topaz: #9dd8d7;
  --uu-mountain-green: #6cc24a;
  --uu-wasatch-sunrise: #ffb81d;
  --uu-aspen-yellow: #efc041;
  --uu-coral-pink-sand-dunes: #e4937b;
  --uu-red-rocks: #890000;
  --uu-header-background: #372c2c;
  --uu-footer-top-bg: #18191b;
  --uu-footer-bottom-bg: #372c2c;
  --uu-footer-links: #d5d5d5;
  --uu-footer-links-bottom: #9d9595;
  --uu-footer-links-hover: #c00;
  --uu-footer-links-hover-bottom: white;
  --uu-breadcrumb-bg: #f6f9fc;
  --uu-light-gray: #e1e1e1;
  --uu-light-gray-bg: #f8f8f8;
  --uu-text-lighter: #515253;
  --uu-text: #18191b;

  /*https://venngage.com/blog/blue-color-palettes/*/
  /* Palette 12 */
  --cp1-indigo: #033f63;
  --cp1-indigo-45: rgb(3, 63, 99);
  --cp1-teal: #28666e;
  --cp1-avocado: #7c9885;
  --cp1-sage: #b5b682;
  --cp1-yellow: #fedc97;

  /* Palette 11 */
  --cp2-teal: #177e89;
  --cp2-teal-lightest: rgb(170, 201, 201);
  --cp2-indigo: #084c61;
  --cp2-red: #db3a34;
  --cp2-sunny: #ffc857;

  /* Palette 3/4 */
  --cp3-blue: #355070;
  --cp3-purple: #6d597a;
  --cp3-purple-5: rgb(109, 89, 122, 0.5);
  --cp3-mauve: #b56576;
  --cp3-pink: #e56b6f;
  --cp3-peach: #eaac8b;
  --cp4-scarlet: #b85042;
  --cp4-light-olive: #e7e8d1;
  --cp4-light-teal: #a7beae;

  /* Another Option */
  --cp5-golden: #f4bb65;
  --cp5-green-apple: #a5b05d;
  --cp5-kelly-green: #609c6a;
  --cp5-teal-1: #2c8275;
  --cp5-teal-2: #226570;
  --cp5-navy: #2f4858;

  /****************************/
  /*-------App Colors---------*/
  /****************************/
  /* Navigation */
  --main-nav-bg-color: var(--uu-header-background);
  --side-nav-bg-color: white;
  --main-nav-link-color: var(--uu-utah-red);
  --site-icon-color: var(--uu-utah-red);
  --site-avatar-color: var(--uu-mountain-green);

  /* Warning */
  --site-error-color: var(--bp-red3);
  --site-warning-color: var(--bp-red2);

  /* App background */
  --primary-bg-color: var(--uu-light-gray-bg);
  --secondary-bg-color: var(--uu-salt-flat-gray);

  --primary-bos-color: var(--uu-lake-powell);
  --primary-button-hover-color: var(--uu-great-salt-lake);
  --secondary-bos-color: var(--uu-red-rocks);
  --primary-hover-color: var(--uu-utah-red-hover);

  /* Selected */
  --selected-row-bg-color: var(--uu-blue-topaz);

  /* Status */
  --status_new: var(--cp1-avocado);
  --status_submitted: var(--bp-red2);
  --status_approved: var(--uu-red-rocks);
  --status_transaction_created: var(--bp-orange4);
  --status_purchased: var(--bp-cerulean3);
  --status_received: var(--cp5-teal-2);
  --status_rejected: var(--cp3-purple-5);
  --status_active: var(--cp2-teal);
  --status_inactive: var(--cp2-teal-lightest);

  --required-input: var(--bp-red2);
}

/* Classes */
.colors-module_primary_background_XX6iw {
  background-color: var(--primary-bg-color);
}

.colors-module_primary_color_RhpIH {
  color: var(--primary-bos-color);
}

.colors-module_primary_button_color_N17pv {
  color: var(--primary-bos-color);
}

.colors-module_primary_button_hover_color_ue9_h {
  color: var(--uu-great-salt-lake);
}

.colors-module_secondary_color_rReJB {
  color: var(--secondary-bos-color);
}

.colors-module_secondary_background_Gc2ng {
  background-color: var(--secondary-bg-color);
}

.colors-module_row_selected_background_Wjnbe {
  background-color: var(--selected-row-bg-color);
}

.colors-module_active_status_background_wKvsO {
  background-color: var(--status_active) !important;
}

.colors-module_deactivate_status_background_PXcdi {
  background-color: var(--site-error-color) !important;
}

.colors-module_inactive_status_y7AzQ {
  background-color: var(--status_inactive) !important;
}

.colors-module_muted_text_ynYkH {
  color: var(--muted-text) !important;
}

.colors-module_error_field_bIwuB {
  color: var(--site-error-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/styles/colors.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;;EAEvB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;;EAE1B,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;;EAElB,iDAAiD;EACjD,eAAe;EACf,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;;EAErB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;;EAEpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;;EAEzB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;;EAEnB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,gDAAgD;EAChD,0BAA0B;EAC1B,yCAAyC;EACzC,qCAAqC;EACrC,6CAA6C;;EAE7C,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;;EAEpC,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;;EAE9C,0CAA0C;EAC1C,uDAAuD;EACvD,0CAA0C;EAC1C,+CAA+C;;EAE/C,aAAa;EACb,6CAA6C;;EAE7C,WAAW;EACX,gCAAgC;EAChC,kCAAkC;EAClC,sCAAsC;EACtC,+CAA+C;EAC/C,uCAAuC;EACvC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,2CAA2C;;EAE3C,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[":root {\n  /****************************/\n  /*------Color Palettes------*/\n  /****************************/\n  /* BluePrint Colors */\n  --bp-light-gray1: #d3d8de;\n  --bp-light-gray2: #dce0e5;\n  --bp-light-gray3: #edeff2;\n  --bp-light-gray4: #edeff2;\n  --bp-light-gray5: #f6f7f9;\n  --bp-gray3: #8f99a8;\n  --bp-gray4: #abb3bf;\n  --bp-gray5: #c5cbd3;\n  --bp-dark-gray4: #383e47;\n  --bp-dark-gray5: #404854;\n  --bp-red2: #ac2f33;\n  --bp-red3: #cd4246;\n  --bp-orange4: #ec9a3c;\n  --bp-gold4: #f0b726;\n  --bp-cerulean3: #147eb3;\n\n  --muted-text: #5f6b7c;\n  --text-color: #1c2127;\n  --text-med-color: #262c31;\n  --text-dark-color: #18191b;\n\n  /* UU Brand Colors */\n  --uu-utah-red: #be0000;\n  --uu-utah-red-hover: #930000;\n  --uu-granite-peak: #708e99;\n  --uu-zion-cinder-cone: #707271;\n  --uu-gray-50: #939598;\n  --uu-salt-flat-gray: #e2e6e6;\n  --uu-lake-powell: #4f868e;\n  --uu-great-salt-lake: #3abfc0;\n  --uu-blue-topaz: #9dd8d7;\n  --uu-mountain-green: #6cc24a;\n  --uu-wasatch-sunrise: #ffb81d;\n  --uu-aspen-yellow: #efc041;\n  --uu-coral-pink-sand-dunes: #e4937b;\n  --uu-red-rocks: #890000;\n  --uu-header-background: #372c2c;\n  --uu-footer-top-bg: #18191b;\n  --uu-footer-bottom-bg: #372c2c;\n  --uu-footer-links: #d5d5d5;\n  --uu-footer-links-bottom: #9d9595;\n  --uu-footer-links-hover: #c00;\n  --uu-footer-links-hover-bottom: white;\n  --uu-breadcrumb-bg: #f6f9fc;\n  --uu-light-gray: #e1e1e1;\n  --uu-light-gray-bg: #f8f8f8;\n  --uu-text-lighter: #515253;\n  --uu-text: #18191b;\n\n  /*https://venngage.com/blog/blue-color-palettes/*/\n  /* Palette 12 */\n  --cp1-indigo: #033f63;\n  --cp1-indigo-45: rgb(3, 63, 99);\n  --cp1-teal: #28666e;\n  --cp1-avocado: #7c9885;\n  --cp1-sage: #b5b682;\n  --cp1-yellow: #fedc97;\n\n  /* Palette 11 */\n  --cp2-teal: #177e89;\n  --cp2-teal-lightest: rgb(170, 201, 201);\n  --cp2-indigo: #084c61;\n  --cp2-red: #db3a34;\n  --cp2-sunny: #ffc857;\n\n  /* Palette 3/4 */\n  --cp3-blue: #355070;\n  --cp3-purple: #6d597a;\n  --cp3-purple-5: rgb(109, 89, 122, 0.5);\n  --cp3-mauve: #b56576;\n  --cp3-pink: #e56b6f;\n  --cp3-peach: #eaac8b;\n  --cp4-scarlet: #b85042;\n  --cp4-light-olive: #e7e8d1;\n  --cp4-light-teal: #a7beae;\n\n  /* Another Option */\n  --cp5-golden: #f4bb65;\n  --cp5-green-apple: #a5b05d;\n  --cp5-kelly-green: #609c6a;\n  --cp5-teal-1: #2c8275;\n  --cp5-teal-2: #226570;\n  --cp5-navy: #2f4858;\n\n  /****************************/\n  /*-------App Colors---------*/\n  /****************************/\n  /* Navigation */\n  --main-nav-bg-color: var(--uu-header-background);\n  --side-nav-bg-color: white;\n  --main-nav-link-color: var(--uu-utah-red);\n  --site-icon-color: var(--uu-utah-red);\n  --site-avatar-color: var(--uu-mountain-green);\n\n  /* Warning */\n  --site-error-color: var(--bp-red3);\n  --site-warning-color: var(--bp-red2);\n\n  /* App background */\n  --primary-bg-color: var(--uu-light-gray-bg);\n  --secondary-bg-color: var(--uu-salt-flat-gray);\n\n  --primary-bos-color: var(--uu-lake-powell);\n  --primary-button-hover-color: var(--uu-great-salt-lake);\n  --secondary-bos-color: var(--uu-red-rocks);\n  --primary-hover-color: var(--uu-utah-red-hover);\n\n  /* Selected */\n  --selected-row-bg-color: var(--uu-blue-topaz);\n\n  /* Status */\n  --status_new: var(--cp1-avocado);\n  --status_submitted: var(--bp-red2);\n  --status_approved: var(--uu-red-rocks);\n  --status_transaction_created: var(--bp-orange4);\n  --status_purchased: var(--bp-cerulean3);\n  --status_received: var(--cp5-teal-2);\n  --status_rejected: var(--cp3-purple-5);\n  --status_active: var(--cp2-teal);\n  --status_inactive: var(--cp2-teal-lightest);\n\n  --required-input: var(--bp-red2);\n}\n\n/* Classes */\n.primary_background {\n  background-color: var(--primary-bg-color);\n}\n\n.primary_color {\n  color: var(--primary-bos-color);\n}\n\n.primary_button_color {\n  color: var(--primary-bos-color);\n}\n\n.primary_button_hover_color {\n  color: var(--uu-great-salt-lake);\n}\n\n.secondary_color {\n  color: var(--secondary-bos-color);\n}\n\n.secondary_background {\n  background-color: var(--secondary-bg-color);\n}\n\n.row_selected_background {\n  background-color: var(--selected-row-bg-color);\n}\n\n.active_status_background {\n  background-color: var(--status_active) !important;\n}\n\n.deactivate_status_background {\n  background-color: var(--site-error-color) !important;\n}\n\n.inactive_status {\n  background-color: var(--status_inactive) !important;\n}\n\n.muted_text {\n  color: var(--muted-text) !important;\n}\n\n.error_field {\n  color: var(--site-error-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary_background": `colors-module_primary_background_XX6iw`,
	"primary_color": `colors-module_primary_color_RhpIH`,
	"primary_button_color": `colors-module_primary_button_color_N17pv`,
	"primary_button_hover_color": `colors-module_primary_button_hover_color_ue9_h`,
	"secondary_color": `colors-module_secondary_color_rReJB`,
	"secondary_background": `colors-module_secondary_background_Gc2ng`,
	"row_selected_background": `colors-module_row_selected_background_Wjnbe`,
	"active_status_background": `colors-module_active_status_background_wKvsO`,
	"deactivate_status_background": `colors-module_deactivate_status_background_PXcdi`,
	"inactive_status": `colors-module_inactive_status_y7AzQ`,
	"muted_text": `colors-module_muted_text_ynYkH`,
	"error_field": `colors-module_error_field_bIwuB`
};
export default ___CSS_LOADER_EXPORT___;
